export class SelectedItemIdDto {
  id?: number;
  name?: string;
}
